import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  return_icon,
  plus_icon,
  star_icon,
  right_scroll,
  left_scroll,
  search_image,
  SessionDeco,
  info_icon
} from "../../assets";

import { GiftOutlined } from "@ant-design/icons"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ProductBox } from "./sessioncomponents/ProductBox";
import ProductSearchBar from "./sessioncomponents/ProductSearchBar";
import ProductGrid from "./sessioncomponents/ProductGrid";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import axiosInstance from "../../AxiosInstance";
import OpeningCash_Modal from "../Modal/OpeningCash_Modal";
import {
  getcategorydata,
  sessionstatesave,
} from "../../Redux/Action/sessionidentifierAction";
import { useDispatch } from "react-redux";
// import { debounce } from 'lodash';
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { addProducts, clearProducts } from "../../Redux/Action/productsAction";
import BarcodeReader from "react-barcode-reader";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { addDraftOrder } from "../../Redux/Action/draftOrdersAction";
import { clearCustomer } from "../../Redux/Action/getcustomerAction";
import { setForRefund } from "../../Redux/Action/refundAction";
import { removeFav } from "../../Redux/Action/removeFavAction";
import { clearPaymentMethod } from "../../Redux/Action/paymentAction";
import PasswordModal from "../Modal/Password_Modal";
import {
  InventorySearchonboardBarcode,
  verifyPassword,
} from "../../API/API Functions/ProductRequest_API";
import AddProductModal from "../Modal/AddProductModal";
import RequestProductModal from "../Modal/RequestProductModal";
import NewGroup_Modal from "../Modal/NewGroup_Modal";
import MoveProductsModal from "../Modal/MoveProducts_Modal";
import { Modal } from "antd";
import AddGroupProduct_Modal from "../Modal/AddGroupProduct";
import groupModalReducer from "../../Redux/Reducers/groupModalOpenReducer";
import {
  closeGroupModal,
  openGroupModal,
} from "../../Redux/Action/groupModalOpenAction";
import { openingCash } from "../../Redux/Action/loginAction";
import ShortCodeSearchBar from "./sessioncomponents/ShortCodeSearchBar";
import { detectWebDeviceType } from "../../utils";
import axios from "axios";
import FreeOfferModal from "./sessioncomponents/FreeOfferModal"; // adjust path


const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 100 }}
      className="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur"
    >
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};

const NewOrderButton = ({ onClick }) => {
  const { t, i18n } = useTranslation();
  return (
    <div
      onClick={onClick}
      className="flex justify-center px-4 py-2 font-semibold bg-[#1b4597] text-white whitespace-nowrap rounded-lg cursor-pointer"
    >
      <img
        src={plus_icon}
        alt="plus_icon"
        className=" mt-1 shrink-0 self-start w-5 aspect-[0.96]"
      />
      <div className="mt-0.5 ml-1">{t("New Order")}</div>
    </div>
  );
};

const NewGroupButton = ({ onClick }) => {
  const { t, i18n } = useTranslation();
  return (
    <div
      onClick={onClick}
      className="flex justify-center px-4 py-2 font-semibold bg-[#7C4DFF] text-white whitespace-nowrap rounded-lg cursor-pointer"
    >
      <img
        src={plus_icon}
        alt="plus_icon"
        className=" mt-1 shrink-0 self-start w-5 aspect-[0.96]"
      />
      <div className="mt-0.5 ml-1">{t("Create Group")}</div>
    </div>
  );
};

// const CategoryButton = ({ children, active, highlighted, onClick }) => (
//   <button
//     className={`flex-none justify-center px-5 py-2 mt-2 border border-solid border-stone-300 rounded-lg font-bold shadow-sm mr-2 ${active
//       ? "text-white bg-[#76CFEE]"
//       : highlighted
//         ? "text-gray-600 bg-[#E0F7FA]"
//         : "text-gray-600 bg-white"
//       }`}
//     onClick={onClick}
//   >
//     {children}
//   </button>
// );

const CategoryButton = ({
  children,
  active,
  highlighted,
  onClick,
  type = "category", // "category" | "group"
}) => {
  const colors = {
    category: {
      active: "text-white bg-[#76CFEE]",
      highlighted: "text-gray-600 bg-[#E0F7FA]",
      default: "text-gray-600 bg-white",
    },
    group: {
      active: "text-white bg-[#7C4DFF]",
      highlighted: "text-gray-700 bg-[#7C4DFF80]",
      default: "text-gray-700 bg-[#7C4DFF20]",
    },
    hamper: {
      active: "text-[#FD8A01] bg-[#FFEEDD] border border-[#FFD2A6]",
      highlighted: "text-gray-600 bg-[#E0F7FA]",
      default: "text-gray-600 bg-white",
    },
    offer: {
      active: "text-white bg-[#4F7BFF] border border-[#4F7BFF]",
      highlighted: "text-gray-600 bg-white",
      default: "text-gray-600 bg-white",
    },
  };

  const palette = colors[type] || colors.category;

  return (
    <button
      className={`flex-none justify-center px-5 py-2 mt-2 border border-solid border-stone-300 rounded-lg font-bold shadow-sm mr-2 transition-colors duration-200
        ${active
          ? palette.active
          : highlighted
            ? palette.highlighted
            : palette.default
        }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

function CategorySkeleton() {
  return (
    <Stack direction="row" spacing={1} sx={{ marginTop: "0.5rem" }}>
      <Skeleton variant="rounded" width={60} height={35} />
      <Skeleton variant="rounded" width={90} height={35} />
      <Skeleton variant="rounded" width={90} height={35} />
      <Skeleton variant="rounded" width={100} height={35} />
      <Skeleton variant="rounded" width={100} height={35} />
      <Skeleton variant="rounded" width={100} height={35} />
      <Skeleton variant="rounded" width={90} height={35} />
      <Skeleton variant="rounded" width={90} height={35} />
      <Skeleton variant="rounded" width={100} height={35} />
      <Skeleton variant="rounded" width={100} height={35} />
      <Skeleton variant="rounded" width={100} height={35} />
    </Stack>
  );
}

function ProductGridSkeleton() {
  const rows = 3;
  const columns = 6;

  return (
    <div>
      {[...Array(rows)].map((_, rowIndex) => (
        <Stack
          key={rowIndex}
          direction="row"
          spacing={1}
          sx={{ marginTop: rowIndex === 0 ? "1rem" : "1rem" }}
        >
          {[...Array(columns)].map((_, colIndex) => (
            <Stack
              key={colIndex}
              spacing={1}
              sx={{ marginLeft: "10px !important" }}
            >
              <Skeleton variant="rounded" width={165} height={152} />
              <Skeleton
                variant="text"
                width={120}
                sx={{ fontSize: "0.5rem", marginTop: "2rem" }}
              />
              <Skeleton
                variant="text"
                width={100}
                sx={{ fontSize: "0.5rem", marginTop: "2rem" }}
              />
            </Stack>
          ))}
        </Stack>
      ))}
    </div>
  );
}

const DRAFT_ORDER_KEY = "draftOrder";

const ProductCo = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { draftOrder } = location.state || {};
  const { store_id } = useSelector((state) => state?.login?.user);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState(
    draftOrder?.products || [],
  );
  const [isScrollAtStart, setIsScrollAtStart] = useState(true);
  const [isScrollAtEnd, setIsScrollAtEnd] = useState(false);
  const [categories, setcategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [productsLoading, setProductsLoading] = useState(true);
  const { OpenCashModal } = useSelector((state) => state?.sessionIdentify);
  const carouselRef = useRef(null);
  const searchInputRef = useRef(null);
  const shortCodeInputRef = useRef(null);
  const [search, setsearch] = useState("");
  const [categoryid, setcategoryid] = useState(null);
  const [isfav, setisfav] = useState(false);
  const [isCartCleared, setIsCartCleared] = useState(false);
  const [products, setProducts] = useState([]);
  const [shortcutProducts, setShortCutProducts] = useState([]);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.login?.user?.result);
  const localProducts = useSelector((state) => state.products.products);
  const { selectedCustomer } = useSelector((state) => state.getcustomer);
  const [isCategorySelectionActive, setIsCategorySelectionActive] =
    useState(false);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const [isScannerActive, setIsScannerActive] = useState(false);
  const [isSelectActive, setIsSelectActive] = useState(false);
  const [isHamperButton, setIsHampleButtom] = useState(false);
  const [isOfferButton, setIsOfferButton] = useState(false)
  const [openMoveProduct, setOpenMoveProduct] = useState(false);
  const [selectedGroupProducts, setSelectedGroupProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [userSelectedIndex, setUserSelectedIndex] = useState(null);
  const [categorySelected, setCategorySelected] = useState(false);

  const [offerSelected, setOfferSelected] = useState("buy_x_get_y")
  const [shortCutSearchValue, setShortcutSearchValue] = useState("");

  const [offerTypes, setOfferTypes] = useState([])

  const offerSelectionsRef = useRef({}); // { [parentProdId]: { eligibleKey, selectedPromotionId } }
  const [pendingFreeOffer, setPendingFreeOffer] = useState(null); // { parentProduct, eligibleOffers }


  const [offers, setOffers] = useState([])


  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    if (isOfferButton) {
      GetAllOfferProducts()
    }
  }, [isOfferButton, offerSelected])

  const returnProducts = useSelector(
    (state) => state.returnProductReducer.products,
  );

  const allowProductShortcut = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_product_shortcut,
  );
  const allowCreateOrEditGroups = useSelector(
    (state) =>
      state?.permissionReducer?.permissions?.is_allow_edit_product_group,
  );

  const negativeSale = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_negative_sale,
  );
  const openCashAllow = useSelector(
    (state) => state?.login?.user?.result?.is_allow_opening_cash,
  );
  const deviceType = detectWebDeviceType();
  useEffect(() => {
    if (!openCashAllow && OpenCashModal) {
      const response = dispatch(openingCash(userData?.session_id, 0));

      dispatch(sessionstatesave(false));
    }
  }, []);

  const [highlightedCategoryIndex, setHighlightedCategoryIndex] =
    useState(null);

  const [focusedProductIndex, setFocusedProductIndex] = useState(null);
  const [isProductSelectionActive, setIsProductSelectionActive] =
    useState(false);

  const updateFav = useSelector((state) => state.removeFavReducer.removeFav);
  const [productToRequest, setProductToRequest] = useState(false);
  const [requestProducModal, setRequestProducModal] = useState(false);
  const [addProducModal, setAddProducModal] = useState(false);
  const [barocdeTOSarch, setBarocdeTOSarch] = useState("");
  const [productToAdd, setProductToAdd] = useState({});
  const [deleteProduct, setDeleteProduct] = useState({});
  const [openPassword, setOpenPassword] = useState(false);
  const [groupModal, setGroupModal] = useState(false);
  const [addGroupProductModal, setAddGroupProductModal] = useState(false);
  const [groups, setGroups] = useState([]);
  const [activeGroupId, setActiveGroupId] = useState(null);

  const activeGroup = groups?.find((g) => g.id === activeGroupId);
  console.log("ACTIVE GROUP", activeGroup)
  const activeSubgroups = activeGroup?.sub_group_list || [];

  const [activeSubgroupId, setActiveSubgroupId] = useState(null);
    const isAllSubgroupSelected = activeSubgroupId === "all";


 useEffect(() => {
  if (activeSubgroups.length > 0) {
    setActiveSubgroupId("all");
    getGroupProducts(activeGroupId, true); // fetch all products by default
  } else {
    setActiveSubgroupId(null);
  }
}, [activeGroupId, activeSubgroups]);



  const handleSubgroupClick = (subId) => {
  setActiveSubgroupId(subId);
  setActiveIndex(null);
  setcategoryid(null);
  setSelectedCategoryIndex(null);
  setIsCategorySelectionActive(null);
  setHighlightedCategoryIndex(0);
  setIsProductSelectionActive(false);
  setFocusedProductIndex(null);

  if (subId === "all") {
    getGroupProducts(activeGroupId, true);
  } else {
    getGroupProducts(subId, false);
  }
};

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const showDash = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_dashboard_show,
  );
  const contractType = useSelector(
    (state) => state?.permissionReducer?.permissions?.contract_type
  );
  const showCategoriesBasedOnContract = contractType != "Cashier"

  const requiredPass = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_password_restrict,
  );

  const showFav = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_favorite_show,
  );

  const showcategory = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_all_categ_show,
  );

  const allowAddProduct = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_add_product,
  );
  const closePasswordModal = () => {
    setOpenPassword(false);
    setDeleteProduct({});
  };
  const [isSelect, setIsSelect] = useState(false);

  const AddProductID = productToAdd?.prod_id;

  const productsRef = useRef(localProducts);

  // 2. Keep the ref in sync whenever state updates
  useEffect(() => {
    productsRef.current = localProducts;
  }, [localProducts]);



  const handleLoadMore = () => {
    if (!isLoadingMore && hasMore) getProducts('', "TEXT", 0, true, offset);
  };


  useEffect(() => {
    if (updateFav == true) {
      handleFavoriteCategoryClick();
    }
  }, [updateFav]);

  useEffect(() => {
    dashboardFunctions();
    // dispatch(clearPaymentMethod())
  }, []);

  useEffect(() => {
    if (isScannerActive) {
      setUserSelectedIndex(null);
    }
  }, [isScannerActive]);

  const dashboardFunctions = async () => {
    const isLangCalled = await setSystyemLang();
    if (isLangCalled) {
      setProductsLoading(true);
      if (showCategoriesBasedOnContract) {
        getcategories();
      } else {
        setCategoriesLoading(false);
      }
      getGroups();
      if (showFav === true) {
        handleFavoriteCategoryClick();
      } else {
        handleCategoryClick(0, 0, true);
      }
    }
  };



  useEffect(() => {
    if (!isCartCleared && location.state && location.state.draftOrder) {
      dispatch(addProducts(location.state.draftOrder.products));
      console.trace("addProducts from clear cart");

    }
  }, [location.state, isCartCleared]);

  useEffect(() => {
    if (!isCartCleared) {
    }
  }, [draftOrder, isCartCleared]);

  const getGroups = async () => {
    setLoading(true);
    try {
      const payload = {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };

      const res = await axiosInstance.post(URLS.GET_PRODUCT_GROUPS, payload);
      // V4 returns { status_code, status, product_groups } at the top level;
      // fall back to the old result[0] shape in case an older endpoint is still in use.
      const result = res?.data?.result?.[0] ?? res?.data;

      if (result?.status_code === 200) {
        const formattedGroups = (result?.product_groups || []).map((g) => ({
          id: g?.id,
          name: g?.name,
          no_of_products: g?.no_of_products,
          sub_group_list: (g?.sub_group_list || []).map((sg) => ({
            id: sg?.id,
            name: sg?.name,
            no_of_products: sg?.no_of_products,
          })),
        }));
        setGroups(formattedGroups);
      } else {
        toast.error(result?.status || "فشل في جلب المجموعات");
        setGroups([]);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
      toast.error("حدث خطأ أثناء تحميل المجموعات");
      setGroups([]);
    } finally {
      setLoading(false);
    }
  };

  const getGroupProducts = async (groupId, sendAll = false) => {
  try {
    setProductsLoading(true);

    const payload = {
      user_id: userData?.user_id,
      company_id: userData?.company_id,
      group_id: groupId,
      is_all: sendAll,
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
    };

    const res = await axiosInstance.post(URLS.GET_GROUP_PRODUCTS, payload);
    const result = res?.data?.result?.[0];

    if (result?.status_code === 200) {
      setProducts(result?.product_list || []);
    } else {
      toast.error(result?.status || "Failed to load group products");
      setProducts([]);
    }
  } catch (error) {
    console.error("Error fetching group products:", error);
    toast.error("حدث خطأ أثناء تحميل منتجات المجموعة");
    setProducts([]);
  } finally {
    setProductsLoading(false);
  }
};

  const getcategories = async () => {
    setCategoriesLoading(true);
    const response = await axiosInstance.post(URLS.GET_CATEGORIES, {
      company_id: userData?.company_id,
    });
    if (response?.data?.result[0]?.status_code === 200) {
      setcategories(response?.data?.result[0]?.response);

      if (showFav === true) {
        setActiveIndex(0);
        setcategoryid("fav");
        setActiveGroupId(null);
      } else {
        setActiveIndex(1);
        setcategoryid(0);
        setActiveGroupId(null);
      }
    }
    setCategoriesLoading(false);
  };

  const setSystyemLang = async () => {
    const response = await axiosInstance.post(URLS.CHANGE_LANGUAGE, {
      code: i18n.language,
    });
    if (response?.data?.result?.status_code === 200) {
      return true;
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const getProducts = async (val, searchBy, cat_id, isFavorite = false, offset = 0, requestId = requestIdRef.current) => {
    if (searchBy === "BARCODE") {
      setProductsLoading(false);
    }
    let payload;

    const existingProductIndex = localProducts?.findIndex(
      (item) => item.barcode === val,
    );

    if (existingProductIndex !== -1 && searchBy === "BARCODE") {
      const product = localProducts[existingProductIndex];
      handleSelectProduct(product, val);
      return;
    }
    if (searchBy === "TEXT") {
      payload = {
        company_id: userData.company_id,
        parent_category_id: cat_id || 0,
        product_name: val,
        is_favorite: isFavorite,
        barcode: "",
        limit: 48,
        offset: offset,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
    } else {
      payload = {
        company_id: userData.company_id,
        parent_category_id: cat_id || 0,
        product_name: "",
        is_favourite: isFavorite,
        barcode: val,
        limit: 48,
        offset: offset,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
    }
    if (val === "" || val?.length > 2) {
      const response = await axiosInstance.post(
        URLS.GET_CATEGORY_PROD,
        payload,
      );
      // console.log("Response Data: ", response?.data?.result[0]?.response);

      if (requestId !== requestIdRef.current) {
        return;
      }

      if (searchBy === "BARCODE") {
        const result = response?.data?.result[0];
        if (result?.status_code === 200 && result?.response) {
          handleSelectProduct(
            result.response[0]?.is_package
              ? result.response[0]
              : result.response,
            val,
          );
        } else {
          if (allowAddProduct) {
            searchBarcodeResult(val);
          } else {
            toast.error(t("Product Not Found"));
          }
          // setBarocdeTOSarch(val);
          // setAddProducModal(true);
          // setrequestProduct(true);
        }
      } else {
        setProductsLoading(true);
        if (response?.data?.result[0]?.response?.length > 0) {
          const newItems = response.data.result[0].response;
          // setProducts(response.data.result[0].response);
          if (isFavorite && offset > 0) {
            setProducts((prev) => {
              const existingIds = new Set(prev.map(item => item.prod_id));

              const filteredItems = newItems.filter(
                item => !existingIds.has(item.prod_id)
              );

              return [...prev, ...filteredItems];
            });


          } else {
            setProducts(newItems)
          }
          if (isFavorite) {
            if (newItems.length < 48) setHasMore(false);
            setOffset(offset + 48);

          }

        } else {
          if (offset == 0 || !isFavorite) {
            setProducts([]);
          }
          if (isFavorite) {
            setHasMore(false);
          }
          // setrequestProduct(true);
        }
      }
    } else {
      setProducts([]);
      // setrequestProduct(true);
    }

    setProductsLoading(false);
    setIsScannerActive(false);
  };

  const getProductsSearch = async (val, searchBy) => {
    if (val == "") {
      let isFav = categoryid == "fav";
      getProducts("", "TEXT", 0, isFav);
      return;
    }
    if (searchBy === "BARCODE") {
      setProductsLoading(false);
    }
    let payload;

    const existingProductIndex = localProducts?.findIndex(
      (item) => item.barcode === val,
    );

    if (existingProductIndex !== -1 && searchBy === "BARCODE") {
      const product = localProducts[existingProductIndex];
      handleSelectProduct(product, val);
      return;
    }
    if (searchBy === "TEXT") {
      payload = {
        company_id: userData.company_id,
        product_name: val,
        barcode: "",
        limit: 50,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
    } else {
      payload = {
        company_id: userData.company_id,
        product_name: "",
        barcode: val,
        limit: 50,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
    }
    if (val === "" || val?.length > 2) {
      const response = await axiosInstance.post(
        URLS.GET_PRODUCT_SEARCH,
        payload,
      );
      // console.log("Response Data: ", response?.data?.result[0]?.response);

      if (searchBy === "BARCODE") {
        const result = response?.data?.result[0];
        if (result?.status_code === 200 && result?.response) {
          handleSelectProduct(result.response[0], val);
        } else {
          if (allowAddProduct) {
            searchBarcodeResult(val);
          } else {
            toast.error(t("Product Not Found"));
          }
          // setBarocdeTOSarch(val);
          // setAddProducModal(true);
          // setrequestProduct(true);
        }
      } else {
        setProductsLoading(true);
        if (response?.data?.result[0]?.response?.length > 0) {
          setProducts(response.data.result[0].response);
        } else {
          setProducts([]);
          // setrequestProduct(true);
        }
      }
    } else {
      setProducts([]);
      // setrequestProduct(true);
    }

    setProductsLoading(false);
    setIsScannerActive(false);
  };

  const getProductsToAdd = async (val) => {
    console.log("#@!@!#@!#@!");

    let payload = {
      company_id: userData.company_id,
      parent_category_id: 0,
      product_name: "",
      is_favourite: false,
      barcode: val,
      limit: 10,
      offset: 0,
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      product_id: val,
    };

    const response = await axiosInstance.post(URLS.GET_CATEGORY_PROD, payload);
    // console.log("Response Data: ", response?.data?.result[0]?.response);

    const result = response?.data?.result[0];
    if (result?.status_code === 200 && result?.response) {
      // console.log("PRIDYYD DD=---->", result.response, val);

      handleSelectProduct(result.response[0], result.response[0]?.barcode);
      handleCategoryClick(0, 0, true);
    }

    setProductsLoading(false);
    setIsScannerActive(false);
  };

  const searchBarcodeResult = async (value) => {
    let res = await InventorySearchonboardBarcode(value);
    if (res.result && Array.isArray(res.result)) {
      const productResponse = res.result[0];
      console.log("productResponse", productResponse);

      if (productResponse.status_code === 400) {
        // Commenting out GS1 search functionality
        try {
          setLoading(true);
          const fetchGtinResponse = await axiosInstance.post(
            process.env.REACT_APP_API_URL_OLD + "/fetch_gs1_data",
            {
              gtin: value,
            },
          );
          const fetchedProduct = fetchGtinResponse?.data?.result;
          if (fetchedProduct.gtin) {
            setRequestProducModal(true);

            setProductToRequest(fetchedProduct);
          } else {
            setRequestProducModal(true);
            setProductToRequest({ barcode: value });
          }
          setLoading(false);
        } catch (error) {
          console.error("Error fetching GS1 data:", error);
        } finally {
          setLoading(false);
        }
      } else {
        // If product is found is myginne inventory
        setAddProducModal(true);
        setProductToAdd(productResponse);
      }
    }
  };

  const debouncedGetProducts = useCallback(
    debounce((val) => {
      setProductsLoading(true);
      setActiveIndex(0);
      setcategoryid(0);
      getProductsSearch(val, "TEXT");
    }, 700),
    [], // make sure this is not recreated on every render
  );

  const debouncedGetShortCutProducts = useCallback(
    debounce((val) => {
      setProductsLoading(true);
      setActiveIndex(0);
      setcategoryid(0);
      getShortcutsProducts(val);
    }, 700),
    [], // make sure this is not recreated on every render
  );

  const getShortcutsProducts = async (val) => {
    let payload;
    payload = {
      company_id: userData.company_id,
      user_id: userData.user_id,
      product_shortcut: val,
      limit: 50,
      offset: 0,
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
    };
    const response = await axiosInstance.post(
      URLS.GET_SHORTCUT_PRODUCTS,
      payload,
    );
    // console.log("Response Data: ", response?.data?.result[0]?.response);
    // setProductsLoading(true);
    if (response?.data?.result[0]?.status_code == 200) {
      setShortCutProducts(response?.data?.result[0]?.response);
    } else {
      setShortCutProducts([]);
      toast.error(t("No product found with this short code"));
      // setrequestProduct(true);
    }
    setProductsLoading(false);
    setIsScannerActive(false);
  };

  const handleNewOrderClick = () => {
    if (localProducts && Object.keys(localProducts).length > 0) {
      const now = new Date();
      const draftOrder = {
        id: Date.now(),
        customer: selectedCustomer ? selectedCustomer : undefined,
        items: localProducts,
        date: now.toISOString().split("T")[0],
        time: now.toTimeString().split(" ")[0],
        total: Object.values(localProducts).reduce(
          (total, item) => total + item.sale_price * item.quantity,
          0,
        ),
      };
      dispatch(addDraftOrder(draftOrder));
      // console.log("CHLAAAA");
      dispatch(clearProducts());
      setFocusedProductIndex(false);
      setIsProductSelectionActive(false);
      dispatch(clearCustomer());
    }
  };

  const GetPackages = async (prod) => {
    let payload = {
      product_id: prod.prod_id,
      user_id: userData?.user_id,
      company_id: userData?.company_id,
    };
    try {
      const response = await axiosInstance.post(
        URLS.GET_SECONDARY_PACKAGES,
        payload,
      );
      console.log("GetPackages===>", response?.data?.result?.success == 200);
      if (response?.data?.result?.success == 200) {
        // setPackageData(response?.data?.result?.data)
        return response?.data?.result?.data;
      } else {
        return [];
      }
    } catch (error) { }
  };
  // const handleSelectProduct = async (product, text) => {
  //   if (!negativeSale && product?.qty_available <= 0) {
  //     toast.error(t("Negative sale is not allowed"));
  //     return;
  //   }

  //   if (product.is_package && product.pack_id) {
  //     product.sale_price = product.pack_price;
  //   }

  //   if (!Array.isArray(localProducts)) {
  //     console.error("localProducts is not an array:", localProducts);
  //     return;
  //   }

  //   if (product.weight && (!text || text.length !== 13)) {
  //     toast.error(t("Please check the barcode"));
  //     return;
  //   }

  //   const updatedProducts = [...localProducts];

  //   // Check if the product already exists
  //   const existingProductIndex = updatedProducts.findIndex((p) => {
  //     const isSameProd = p.prod_id === product.prod_id;
  //     const isSamePack =
  //       product.pack_id != null ? p.pack_id === product.pack_id : !p.pack_id;
  //     return isSameProd && isSamePack;
  //   });
  //   const isNewProduct = existingProductIndex === -1;
  //   if (isNewProduct) {
  //     setIsSelect(true);
  //   }
  //   if (
  //     updatedProducts[existingProductIndex]?.quantity >=
  //       product?.qty_available &&
  //     !negativeSale
  //   ) {
  //     toast.error(t("Negative sale is not allowed"));
  //     return;
  //   }

  //   if (existingProductIndex !== -1) {
  //     // Product exists → increase quantity

  //     if (
  //       product?.weight &&
  //       text?.startsWith(String(product.machine_barcode))
  //     ) {
  //       const weightInKg = product.weight / 1000;
  //       const updatedQuantity =
  //         updatedProducts[existingProductIndex].quantity + weightInKg;
  //       updatedProducts[existingProductIndex].quantity = parseFloat(
  //         updatedQuantity.toFixed(3),
  //       );
  //     } else {
  //       updatedProducts[existingProductIndex].quantity += 1;
  //     }
  //     setSelectedProducts(updatedProducts[existingProductIndex]);
  //   } else {
  //     // Add product immediately
  //     let quantity = 1;
  //     if (product.weight && text?.startsWith(String(product.machine_barcode))) {
  //       quantity = parseFloat((product.weight / 1000).toFixed(3));
  //     }

  //     const productWithQuantity = { ...product, quantity, packages: [] };
  //     updatedProducts.push(productWithQuantity);
  //     setSelectedProducts(productWithQuantity);
  //   }

  //   dispatch(addProducts(updatedProducts));
  //   setSelectedProducts(updatedProducts);

  //   // Set selected index
  //   const newIndex = updatedProducts.findIndex((p) => {
  //     const isSameProd = p.prod_id === product.prod_id;
  //     const isSamePack =
  //       product.pack_id != null ? p.pack_id === product.pack_id : !p.pack_id;
  //     return isSameProd && isSamePack;
  //   });
  //   setUserSelectedIndex(newIndex);

  //   // 🚀 Call GetPackages in background only if product was newly added
  //   if (existingProductIndex === -1 && product?.is_package) {
  //     try {
  //       const packages = await GetPackages(product);
  //       if (packages?.length) {
  //         const newList = [...updatedProducts];
  //         const targetIndex = newList.findIndex((p) => {
  //           const isSameProd = p.prod_id === product.prod_id;
  //           const isSamePack =
  //             product.pack_id != null
  //               ? p.pack_id === product.pack_id
  //               : !p.pack_id;
  //           return isSameProd && isSamePack;
  //         });

  //         if (targetIndex !== -1) {
  //           newList[targetIndex] = {
  //             ...newList[targetIndex],
  //             packages,
  //           };
  //           dispatch(addProducts(newList));
  //           setSelectedProducts(newList);
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Error fetching packages in background", err);
  //     }
  //   }
  // };


  // shared helper
  const getEgyptNowString = () => {
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Africa/Cairo",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const parts = formatter.formatToParts(new Date());
    const map = {};
    parts.forEach(({ type, value }) => (map[type] = value));
    const hour = map.hour === "24" ? "00" : map.hour;
    return `${map.year}-${map.month}-${map.day} ${hour}:${map.minute}:${map.second}`;
  };

  const isOfferActive = (offer) => {
    if (!offer) return false;
    const now = getEgyptNowString();
    if (offer.start_date && now < offer.start_date) return false;
    if (offer.end_date && now > offer.end_date) return false;
    return true;
  };

  const getEligibleOffers = (currentProduct) => {
    const buyXGetYOffers = (currentProduct.offers || []).filter(
      (o) => o.promo_offer_type === "buy_x_get_y"
    );
    return buyXGetYOffers.filter(
      (offer) => isOfferActive(offer) && currentProduct.quantity >= offer.buy_qty
    );
  };

  const idsKey = (offers) =>
    offers.map((o) => o.promotion_id).sort((a, b) => a - b).join(",");

  const removeFreeProductsForParent = (products, parentProdId) =>
    products.filter(
      (p) => !(p.isFreeProduct && p.parentProductId === parentProdId)
    );

  const applySelectedFreeOffer = (updatedProducts, currentProduct, offer) => {
    const rawFreeQty = offer.repeat_for_multiple
      ? Math.floor(currentProduct.quantity / offer.buy_qty) * offer.free_qty
      : currentProduct.quantity >= offer.buy_qty
        ? offer.free_qty
        : 0;

    const freeQty =
      offer.max_free_per_order > 0
        ? Math.min(rawFreeQty, offer.max_free_per_order)
        : rawFreeQty;

    // Remove all previously selected free products for this parent

    const existingIndex = updatedProducts.findIndex(
      p =>
        p.isFreeProduct &&
        p.parentProductId === currentProduct.prod_id
    );

    // Nothing to add
    if (freeQty === 0) {
      if (existingIndex !== -1) {
        updatedProducts.splice(existingIndex, 1);
      }
      return;
    }

    if (existingIndex !== -1) {
      updatedProducts[existingIndex] = {
        ...updatedProducts[existingIndex],
        quantity: freeQty,
        promotion_id: offer.promotion_id,
        name: offer.free_product_name,
        barcode: offer.free_product_barcode,
        image_url: offer.free_product_image_url,
        sale_price: offer.free_unit_price,
        free_cost_price: offer.free_cost_price,
      };

      return;
    }

    // Add the selected free product
    updatedProducts.push({
      prod_id: offer.free_product_id,
      name: offer.free_product_name,
      barcode: offer.free_product_barcode,
      quantity: freeQty,
      sale_price: offer.free_unit_price,
      free_cost_price: offer.free_cost_price,
      rate: 0,
      discount_type: "",
      discount_value: "",
      vat_details: {},
      isFreeProduct: true,
      promo_offer_type: offer.promo_offer_type,
      parentProductId: currentProduct.prod_id,
      promotion_id: offer.promotion_id,
      image_url: offer.free_product_image_url,
    });
  };

  // 🔥 Replaces the old applyOffers — no longer auto-picks, prompts the user instead
  // 🔥 Auto-applies when there's a single eligible offer; only prompts when there's a real choice
  const getEffectiveFreeQty = (offer, quantity) => {
    const rawQty = offer.repeat_for_multiple
      ? Math.floor(quantity / offer.buy_qty) * offer.free_qty
      : quantity >= offer.buy_qty
        ? offer.free_qty
        : 0;

    return offer.max_free_per_order > 0
      ? Math.min(rawQty, offer.max_free_per_order)
      : rawQty;
  };


  const syncOfferEligibility = (updatedProducts, currentProduct, revertMeta = null) => {

    const eligibleOffers = getEligibleOffers(currentProduct);
    const key = eligibleOffers
      .map((offer) => ({
        id: offer.promotion_id,
        qty: getEffectiveFreeQty(offer, currentProduct.quantity),
      }))
      .sort((a, b) => a.id - b.id)
      .map(({ id, qty }) => `${id}:${qty}`)
      .join("|");

    const prevEntry = offerSelectionsRef.current[currentProduct.prod_id] || {
      eligibleKey: "",
      selectedPromotionId: null,
    };

    if (eligibleOffers.length === 0) {
      const cleaned = removeFreeProductsForParent(updatedProducts, currentProduct.prod_id);
      updatedProducts.splice(0, updatedProducts.length, ...cleaned);
      offerSelectionsRef.current[currentProduct.prod_id] = {
        eligibleKey: "",
        selectedPromotionId: null,
      };
      return true;
    }

    if (key === prevEntry.eligibleKey) {
      if (prevEntry.selectedPromotionId) {
        const offer = eligibleOffers.find(
          (o) => o.promotion_id === prevEntry.selectedPromotionId
        );
        if (offer) {
          applySelectedFreeOffer(updatedProducts, currentProduct, offer);
        }
      }
      return true;
    }

    // const cleaned = removeFreeProductsForParent(
    //   updatedProducts,
    //   currentProduct.prod_id
    // );
    // updatedProducts.splice(0, updatedProducts.length, ...cleaned);

    if (eligibleOffers.length === 1) {
      const onlyOffer = eligibleOffers[0];
      applySelectedFreeOffer(updatedProducts, currentProduct, onlyOffer);

      offerSelectionsRef.current[currentProduct.prod_id] = {
        eligibleKey: key,
        selectedPromotionId: onlyOffer.promotion_id,
      };

      return true;
    }

    const selectedOffer = eligibleOffers.find(
      (o) => o.promotion_id === prevEntry.selectedPromotionId
    );

    if (selectedOffer && revertMeta) {
      const previousFreeQty = getEffectiveFreeQty(
        selectedOffer,
        revertMeta.previousQuantity
      );

      const currentFreeQty = getEffectiveFreeQty(
        selectedOffer,
        currentProduct.quantity
      );

      // Same entitlement -> keep previous selection
      if (previousFreeQty === currentFreeQty) {
        applySelectedFreeOffer(updatedProducts, currentProduct, selectedOffer);

        offerSelectionsRef.current[currentProduct.prod_id] = {
          eligibleKey: key,
          selectedPromotionId: selectedOffer.promotion_id,
        };

        return true;
      }
    }

    offerSelectionsRef.current[currentProduct.prod_id] = {
      eligibleKey: key,
      selectedPromotionId: null,
    };



    setPendingFreeOffer({
      parentProduct: currentProduct,
      eligibleOffers,
      isNewProduct: revertMeta?.isNewProduct ?? false,
      previousQuantity: revertMeta?.previousQuantity ?? 0,
    });

    return false;
  };

  const handleSelectFreeOffer = (offer) => {
    if (!pendingFreeOffer) return;
    const { parentProduct } = pendingFreeOffer;

    const updatedProducts = [...productsRef.current];

    // commit the buy product itself, since it was never added while pending
    const existingIndex = updatedProducts.findIndex(
      (p) =>
        p.prod_id === parentProduct.prod_id &&
        (parentProduct.pack_id != null ? p.pack_id === parentProduct.pack_id : !p.pack_id)
    );
    if (existingIndex === -1) {
      updatedProducts.push(parentProduct);
    } else {
      updatedProducts[existingIndex] = parentProduct;
    }

    applySelectedFreeOffer(updatedProducts, parentProduct, offer);

    offerSelectionsRef.current[parentProduct.prod_id] = {
      ...offerSelectionsRef.current[parentProduct.prod_id],
      selectedPromotionId: offer.promotion_id,
    };

    dispatch(addProducts(updatedProducts));
    console.trace("addProducts from select free offer");

    setSelectedProducts(updatedProducts);
    productsRef.current = updatedProducts;
    setPendingFreeOffer(null);
  };

  const handleCloseFreeOfferModal = () => {
    if (!pendingFreeOffer) return;

    delete offerSelectionsRef.current[pendingFreeOffer.parentProduct.prod_id];
    setPendingFreeOffer(null);
  };

  // Optional: hook this to a "🎁 free item available" chip on the cart row
  const handleReopenFreeOfferModal = (product) => {
    const eligibleOffers = getEligibleOffers(product);
    if (eligibleOffers.length) setPendingFreeOffer({ parentProduct: product, eligibleOffers });
  };

  // const applyOffers = (updatedProducts, currentProduct) => {
  //   const buyXGetYOffers = (currentProduct.offers || []).filter(
  //     (o) => o.promo_offer_type === "buy_x_get_y"
  //   );

  //   // 🔥 Find the single best-matching offer: highest buy_qty
  //   // that the current quantity satisfies (and is currently active).
  //   let bestOffer = null;
  //   buyXGetYOffers.forEach((offer) => {
  //     if (!isOfferActive(offer)) return;
  //     if (currentProduct.quantity >= offer.buy_qty) {
  //       if (!bestOffer || offer.buy_qty > bestOffer.buy_qty) {
  //         bestOffer = offer;
  //       }
  //     }
  //   });

  //   buyXGetYOffers.forEach((offer) => {
  //     const isBestMatch =
  //       bestOffer && offer.promotion_id === bestOffer.promotion_id;

  //     const active = isOfferActive(offer);

  //     // Only the best-matching offer ever produces a free qty;
  //     // all other offers for this product resolve to 0 (which removes
  //     // any free product they previously added).
  //     const rawFreeQty =
  //       !active || !isBestMatch
  //         ? 0
  //         : offer.repeat_for_multiple
  //           ? Math.floor(currentProduct.quantity / offer.buy_qty) * offer.free_qty
  //           : currentProduct.quantity >= offer.buy_qty
  //             ? offer.free_qty
  //             : 0;

  //     const freeQty =
  //       offer.max_free_per_order > 0
  //         ? Math.min(rawFreeQty, offer.max_free_per_order)
  //         : rawFreeQty;

  //     const freeIndex = updatedProducts.findIndex(
  //       (p) =>
  //         p.isFreeProduct &&
  //         p.parentProductId === currentProduct.prod_id &&
  //         p.promotion_id === offer.promotion_id
  //     );

  //     if (freeQty === 0) {
  //       if (freeIndex !== -1) updatedProducts.splice(freeIndex, 1);
  //     } else {
  //       if (freeIndex === -1) {
  //         updatedProducts.push({
  //           prod_id: offer.free_product_id,
  //           name: offer.free_product_name,
  //           barcode: offer.free_product_barcode,
  //           quantity: freeQty,
  //           sale_price: offer.free_unit_price,
  //           free_cost_price: offer.free_cost_price,
  //           rate: 0,
  //           discount_type: "",
  //           discount_value: "",
  //           vat_details: {},
  //           isFreeProduct: true,
  //           promo_offer_type: offer.promo_offer_type,
  //           parentProductId: currentProduct.prod_id,
  //           promotion_id: offer.promotion_id,
  //           image_url: offer.free_product_image_url,
  //         });
  //       } else {
  //         updatedProducts[freeIndex].quantity = freeQty;
  //       }
  //     }
  //   });
  // };

  useEffect(() => {
    // find the soonest-expiring active offer among current cart items
    const activeOfferItems = (localProducts || []).filter(
      (p) => !p.isFreeProduct && Array.isArray(p.offers) && p.offers.length > 0
    );

    if (activeOfferItems.length === 0) return;

    const timers = [];

    activeOfferItems.forEach((product) => {
      (product.offers || []).forEach((offer) => {
        if (!offer.end_date) return;

        const nowEgyptDate = new Date(getEgyptNowString().replace(" ", "T"));
        const endDate = new Date(offer.end_date.replace(" ", "T"));
        const msUntilExpiry = endDate - nowEgyptDate;

        if (msUntilExpiry <= 0) return; // already expired, applyOffers will drop it on next update

        const timer = setTimeout(() => {
          const updatedProducts = [...localProducts];
          const currentIndex = updatedProducts.findIndex(
            (p) => p.prod_id === product.prod_id && p.pack_id === product.pack_id
          );
          if (currentIndex === -1) return;
          syncOfferEligibility(updatedProducts, updatedProducts[currentIndex]);
          dispatch(addProducts(updatedProducts));
          console.trace("addProducts from active offers");

          setSelectedProducts(updatedProducts);
        }, msUntilExpiry + 500); // small buffer past the boundary

        timers.push(timer);
      });
    });

    return () => timers.forEach(clearTimeout);
  }, [localProducts]);

  const handleSelectProduct = async (product, text) => {
    let fetchedOffers = [];
    if (product?.is_offer || product?.offer) {
      try {
        const payload = {
          company_id: userData?.company_id,
          product_id: product?.prod_id,
          limit: 10,
          offset: 0,
        };
        const res = await axiosInstance.post(URLS.GET_PRODUCT_OFFER_DETAILS, payload);
        fetchedOffers = res?.data?.result?.data;
      } catch (error) {
        console.error(error);
      }
    }

    if (!negativeSale && product?.qty_available <= 0) {
      toast.error(t("Negative sale is not allowed"));
      return;
    }
    if (product.weight && (!text || text.length !== 13)) {
      toast.error(t("Please check the barcode"));
      return;
    }

    const updatedProducts = Array.isArray(productsRef.current)
      ? [...productsRef.current]
      : [];

    if (product.is_package && product.pack_id) {
      product = { ...product, sale_price: product.pack_price };
    }

    const existingIndex = updatedProducts.findIndex(
      (p) => {
        return (
          p.prod_id === product.prod_id &&
          (product.pack_id != null ? p.pack_id === product.pack_id : !p.pack_id) && !p.isFreeProduct
        )
      }
    );

    const isNew = existingIndex === -1;
    const projectedAddedQty = product?.offer ? product.qty_available : 1;
    const projectedQty = updatedProducts[existingIndex]?.quantity + projectedAddedQty;

    if (
      !isOfferButton &&
      !isNew &&
      updatedProducts[existingIndex]?.quantity >= product?.qty_available &&
      !negativeSale
    ) {
      toast.error(t("Negative sale is not allowed"));
      return;
    } else if (
      isOfferButton &&
      !isNew &&
      projectedQty >= product?.offer?.buy_available_qty &&
      updatedProducts[existingIndex]?.quantity >= product?.offer?.buy_available_qty &&
      !negativeSale
    ) {
      toast.error(t("Negative sale is not allowed"));
      return;
    }

    let selectedItem;

    if (!isNew) {
      const existingProduct = updatedProducts[existingIndex];
      let addedQty = 1;

      if (product.weight && text?.startsWith(String(product.machine_barcode))) {
        addedQty = parseFloat((product.weight / 1000).toFixed(3));
      } else if (product?.offer) {
        addedQty = product.qty_available;
      }

      const newQuantity = parseFloat((existingProduct.quantity + addedQty).toFixed(3));

      selectedItem = { ...existingProduct, quantity: newQuantity };
      updatedProducts[existingIndex] = selectedItem;

      const shouldCommit = syncOfferEligibility(updatedProducts, selectedItem);
      if (!shouldCommit) {
        // Multiple eligible offers → modal is now pending.
        // Nothing has been written to productsRef/Redux — just stop here.
        return;
      }
    } else {
      let quantity = isOfferButton ? product.qty_available : 1;
      if (product.weight && text?.startsWith(String(product.machine_barcode))) {
        quantity = parseFloat((product.weight / 1000).toFixed(3));
      }

      selectedItem = { ...product, quantity, packages: [], offers: fetchedOffers };
      updatedProducts.push(selectedItem);

      const shouldCommit = syncOfferEligibility(updatedProducts, selectedItem);
      if (!shouldCommit) {
        return; // same reasoning as above
      }
    }

    // 🔽 This is the ONLY place in the whole component that commits to Redux/cart.
    dispatch(addProducts(updatedProducts));

    console.trace("addProducts from select product");

    setSelectedProducts(updatedProducts);
    productsRef.current = updatedProducts;
    setUserSelectedIndex(isNew ? updatedProducts.length - 1 : existingIndex);

    if (isNew && product?.is_package) {
      GetPackages(product)
        .then((packages) => {
          if (!packages?.length) return;

          const newList = [...productsRef.current];

          const index = newList.findIndex(
            p =>
              p.prod_id === product.prod_id &&
              p.pack_id === product.pack_id
          );

          if (index === -1) return;

          newList[index] = {
            ...newList[index],
            packages,
          };
          dispatch(addProducts(newList));
          console.trace("addProducts from select product new ");
          console.log("Snapshot before package update", updatedProducts);

          console.log("Current Redux", productsRef.current);
          console.log(
            "Does productsRef.current already contain the free product?",
            productsRef.current.some(
              p => p.isFreeProduct && p.bill_offer_id
            )
          );

          setSelectedProducts(newList);
          productsRef.current = newList;
        })
        .catch((err) => console.error("Error fetching packages", err));
    }
  };


  const handleDeleteClick = (product) => {
    if (requiredPass === true) {
      setOpenPassword(true);
      setDeleteProduct(product);
    } else {
      setDeleteProduct({});
      setIsSelect(false);
      handleRemoveProduct(product);
    }
  };

  const handlePasswordConfirm = async (enteredPassword) => {
    setLoading(true);
    const userId = userData?.user_id;
    const action = "Product removed from cart";
    try {
      const verificationResult = await verifyPassword(
        userId,
        enteredPassword,
        action,
      );

      if (
        verificationResult &&
        verificationResult?.result?.status_code === 200
      ) {
        handleRemoveProduct(deleteProduct);
        closePasswordModal();
        setLoading(false);
      } else if (verificationResult?.result?.status_code === 400) {
        setLoading(false);
        toast.error(t("Incorrect password"));
        return;
      }
    } catch (error) {
      console.error("Error verifying password:", error);
    }
  };

  const handleRemoveProduct = (product) => {
    if (!Array.isArray(localProducts)) {
      console.error("localProducts is not an array:", localProducts);
      return;
    }

    const updatedProducts = localProducts.filter((p) => {
      // Remove the exact product line (must match free/paid identity too)
      const isTargetProduct = product.pack_id
        ? p.prod_id === product.prod_id &&
        p.pack_id === product.pack_id &&
        !!p.isFreeProduct === !!product.isFreeProduct
        : p.prod_id === product.prod_id &&
        !p.pack_id &&
        !!p.isFreeProduct === !!product.isFreeProduct;

      // Remove any free product spawned by this product (only relevant when
      // removing the paid/buy line — a free line has no children of its own)
      const isOrphanedFreeProduct =
        !product.isFreeProduct &&
        p.isFreeProduct &&
        p.parentProductId === product.prod_id;

      return !(isTargetProduct || isOrphanedFreeProduct);
    });

    dispatch(addProducts(updatedProducts));
    console.trace("addProducts from remove product");

    setSelectedProducts(updatedProducts);
    setUserSelectedIndex(
      updatedProducts.length > 0 ? updatedProducts.length - 1 : null,
    );
  };

  const handleUpdateQuantity = (product, quantity) => {
    console.log("LOGGGG", product, quantity);

    const updatedProducts = [...localProducts];
    console.log("Incoming quantity:", quantity);
    console.log("localProducts:", localProducts);
    const existingProductIndex = updatedProducts.findIndex((p) => {
      const sameLine = product.pack_id
        ? p.prod_id === product.prod_id && p.pack_id === product.pack_id
        : p.prod_id === product.prod_id && !p.pack_id;

      return sameLine && !!p.isFreeProduct === !!product.isFreeProduct;
    });

    const isNewProduct = existingProductIndex === -1;
    if (isNewProduct) {
      setIsSelect(true);
    } else {
      setIsSelect(false);
    }
    if (existingProductIndex !== -1) {
      const currentProduct = updatedProducts[existingProductIndex];
      console.log(currentProduct)
      const updatedProduct = {
        ...currentProduct,
        quantity: Math.max(quantity, 0)
      }
      console.log("Updated Product", updatedProduct)
      updatedProducts[existingProductIndex] = updatedProduct;


      const shouldCommit = syncOfferEligibility(updatedProducts, updatedProduct);
      console.log(shouldCommit)
      if (!shouldCommit) {
        return;
      }
      console.log(
        "Dispatching free product:",
        updatedProducts.find(
          p =>
            p.isFreeProduct &&
            p.parentProductId === currentProduct.prod_id
        )
      );

      dispatch(addProducts(updatedProducts));
      console.trace("addProducts from update quantity");

      setSelectedProducts(updatedProducts)
      productsRef.current = updatedProducts
      return true;
    } else {
      console.warn("Product to update not found:", product);
    }
  };

  const onUpdateSP = (product, price) => {
    const updatedProducts = [...localProducts];

    const existingProductIndex = updatedProducts.findIndex((p) => {
      if (product.pack_id) {
        return p.prod_id === product.prod_id && p.pack_id === product.pack_id;
      } else {
        return p.prod_id === product.prod_id && !p.pack_id;
      }
    });

    if (existingProductIndex !== -1) {
      const existingProduct = updatedProducts[existingProductIndex];

      // 👉 Get correct cost price
      const costPrice = product.pack_id
        ? existingProduct.pack_cost_price || existingProduct.cost_price
        : existingProduct.cost_price;

      if (price < costPrice) {
        toast.error("Sales price cannot be below cost price");
        return;
      }
      updatedProducts[existingProductIndex].discount_type = "";
      updatedProducts[existingProductIndex].discount_value = 0;
      updatedProducts[existingProductIndex].price_after_discount = Number(price);

      // 👉 Save previous price only if actual_price not present
      if (!existingProduct?.actual_price) {
        updatedProducts[existingProductIndex].actual_price =
          product.pack_id
            ? existingProduct.pack_price
            : existingProduct.sale_price;
      }

      // ✅ Update price
      if (product.pack_id) {
        updatedProducts[existingProductIndex].pack_price = Number(price);
        updatedProducts[existingProductIndex].sale_price = Number(price);
      } else {
        updatedProducts[existingProductIndex].sale_price = Number(price);
      }

      // 🚨 RESET DISCOUNT


      dispatch(addProducts(updatedProducts));
      console.trace("addProducts from update sale price");

      setSelectedProducts(updatedProducts);
    } else {
      console.warn("Product to update not found:", product);
    }
  };

  const handleUpdateDiscount = (product, discountData) => {
    // console.log("DISCOUNT UPDATE ===>", product, discountData);

    const updatedProducts = [...localProducts];

    const existingProductIndex = updatedProducts.findIndex((p) => {
      if (product.pack_id) {
        return p.prod_id === product.prod_id && p.pack_id === product.pack_id;
      } else {
        return p.prod_id === product.prod_id && !p.pack_id;
      }
    });

    if (existingProductIndex !== -1) {
      updatedProducts[existingProductIndex].discount_type =
        discountData.discountType;
      updatedProducts[existingProductIndex].discount_value =
        discountData.discountValue;
      updatedProducts[existingProductIndex].price_after_discount =
        discountData.priceAfterDiscount;

      dispatch(addProducts(updatedProducts));
      console.trace("addProducts from update discount");

      setSelectedProducts(updatedProducts);
    } else {
      console.warn("Product to update not found:", product);
    }
  };

  const requestIdRef = useRef(0);


  const handleCategoryClick = async (index, id, apiCall, is_fav) => {
    const requestId = ++requestIdRef.current;

    setProductsLoading(true);
    setActiveIndex(index);
    setcategoryid(id);
    setSelectedCategoryIndex(index);
    setIsCategorySelectionActive(null);
    setHighlightedCategoryIndex(0);
    setIsProductSelectionActive(false);
    setFocusedProductIndex(null);
    setActiveGroupId(null);
    // setIsCategorySelectionActive(false);
    // setFocusedProductIndex(null);
    if (apiCall) {
      getProducts("", "TEXT", id, is_fav, requestId);
    }

  };

  const handleGroupClick = (id) => {
    if (id === activeGroupId) return;

    setActiveGroupId(id);
    setActiveSubgroupId(null);
    setActiveIndex(null);
    setcategoryid(null);
    setSelectedCategoryIndex(null);
    setIsCategorySelectionActive(null);
    setHighlightedCategoryIndex(0);
    setIsProductSelectionActive(false);
    setFocusedProductIndex(null);

    getGroupProducts(id);
  };

  const handleSelectHamper = () => {
    setcategoryid(null);
    setSelectedCategoryIndex(null);
    setIsCategorySelectionActive(null);
    setHighlightedCategoryIndex(0);
    setIsProductSelectionActive(false);
    setFocusedProductIndex(null);
    GetAllHampers();
  };

  const handleSelectOffers = () => {
    const requestId = ++requestIdRef.current;

    setcategoryid(null)
    setSelectedCategoryIndex(null)
    setIsCategorySelectionActive(null)
    setHighlightedCategoryIndex(false)
    setIsProductSelectionActive(false)
    setFocusedProductIndex(null)
    GetAllOffers()
    GetAllOfferProducts(requestId)
  }

  const GetAllOffers = async () => {
    try {
      setProducts([])
      setProductsLoading(true);
      console.log("Selected Offer", offerSelected)
      console.log(userData?.company_id)
      const payload = {
        company_id: userData?.company_id
      }
      const res = await axiosInstance.post(URLS.GET_CASHIER_OFFER_TYPES, payload);
      const result = res?.data?.result;
      console.log("ASSSSSS--->", result);

      if (result?.status_code === 200) {
        const offerTypes = result?.data || [];

        // Keep only the first offer type
        setOfferTypes(offerTypes);
      } else {
        toast.error(result?.status || "Failed to load offers");
        setOfferTypes([]);
      }
    }
    catch (error) {
      console.error("Error fetching Offers:", error);
      toast.error("حدث خطأ أثناء تحميل منتجات المجموعة");
      setOfferTypes([]);
    } finally {
      setProductsLoading(false);
    }
  }

  const GetAllOfferProducts = async (requestId = requestIdRef.current) => {
    try {
      setProductsLoading(true);

      const payload = {
        company_id: userData?.company_id,
        promo_offer_type: offerSelected,
        limit: 10,
        offset: 0,
      };

      const res = await axiosInstance.post(
        URLS.GET_CASHIER_OFFER_PRODUCTS,
        payload
      );

      if (requestId !== requestIdRef.current) {
        return;
      }


      console.log(res)
      const result = res?.data?.result?.data || [];

      console.log("ASSSSSS--->", result);
      const mappedProducts = result.map((offer) => ({
        prod_id: offer.promo_offer_type === "buy_x_get_y" ? offer.buy_product_id : offer.free_product_id,
        name: offer.promo_offer_type === "buy_x_get_y" ? offer.buy_product_name : offer.free_product_name,
        image_url: offer.promo_offer_type === "buy_x_get_y" ? offer.buy_product_image_url : offer.free_product_image_url,
        barcode: offer.promo_offer_type === "buy_x_get_y" ? offer.buy_product_barcode : offer.free_product_barcode,
        sale_price: offer.promo_offer_type === "buy_x_get_y" && !offer.is_offer ? offer.buy_unit_price : offer.free_unit_price,
        qty_available: offer.promo_offer_type === "buy_x_get_y" ? offer.buy_qty : offer.free_qty,

        offer,
        // free_product_id: offer.free_product_id,
        // free_product_name: offer.free_product_name,
        // free_product_image_url: offer.free_product_image_url,
        // free_qty: offer.free_qty,
        promotion_id: offer.promotion_id,
        promo_offer_type: offer.promo_offer_type,
      }));

      setProducts(mappedProducts);
    } catch (error) {
      console.error(error);
      setProducts([]);
    } finally {
      if (requestId === requestIdRef.current) {
        setProductsLoading(false);
      }
    }
  };

  const GetAllHampers = async () => {
    try {
      setProductsLoading(true);

      const payload = {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
        limit: 100,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };

      const res = await axiosInstance.post(URLS.GET_ALL_HAMPERS, payload);
      const result = res?.data?.result?.[0];

      console.log("ASSSSSS--->", result);

      if (result?.status_code === 200) {
        const products = result?.product_list || [];
        setProducts(products);
      } else {
        toast.error(result?.status || "Failed to load group products");
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching group products:", error);
      toast.error("حدث خطأ أثناء تحميل منتجات المجموعة");
      setProducts([]);
    } finally {
      setProductsLoading(false);
    }
  };

  const handleFavoriteCategoryClick = () => {
    // setCurrentCategory("fav");
    setActiveGroupId(null);
    setcategoryid("fav"); // Set categoryid to "fav" when favorite is clicked
    getProducts("", "TEXT", 0, true);
    dispatch(removeFav(false));

    // }
  };

  const handleScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
    setIsScrollAtStart(scrollLeft === 0);
    setIsScrollAtEnd(scrollLeft + clientWidth === scrollWidth);
  };

  const scrollToPrevItem = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollToNextItem = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const [isOrderButtonVisible, setIsOrderButtonVisible] = useState(false);

  const keyMappings = {
    N: ["N", "آ"],
    S: ["S", "ٍ"],
    ArrowRight: ["ArrowRight", "ArrowRight"],
    ArrowLeft: ["ArrowLeft", "ArrowLeft"],
    Backspace: ["Backspace", "ي"],
    Delete: ["Delete", "حذف"],
    Enter: ["Enter", "إدخال"],
    " ": [" ", " "],
    ArrowDown: ["ArrowDown", "تحت"],
  };

  const isKeyMatch = (key, targets) => targets.includes(key);

  const handleKeyDown = (e) => {
    const key = e.key;

    if (e.shiftKey && isKeyMatch(key, keyMappings.N)) {
      e.preventDefault();
      handleNewOrderClick();
      searchInputRef.current.blur();
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault();

        shortCodeInputRef.current?.focus();

        setIsProductSelectionActive(false);
        setIsCategorySelectionActive(false);
        setFocusedProductIndex(null);
        setHighlightedCategoryIndex(0);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleNewOrderClick]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const key = e.key;

      if (e.ctrlKey && isKeyMatch(key, keyMappings.Enter)) {
        e.preventDefault();
        setIsCategorySelectionActive(false);
        setIsProductSelectionActive(false);
        setUserSelectedIndex(false);
        searchInputRef.current.blur();
      }

      if (e.shiftKey && isKeyMatch(key, keyMappings.ArrowRight)) {
        e.preventDefault();
        setFocusedProductIndex(false);
        setIsCategorySelectionActive(true);
        setHighlightedCategoryIndex(0);
        setIsProductSelectionActive(false);
        searchInputRef.current.blur();
      }

      // if (e.shiftKey && isKeyMatch(key, keyMappings.Backspace)) {
      //   e.preventDefault();
      //   dispatch(clearProducts());
      //   setFocusedProductIndex(false);
      //   setIsProductSelectionActive(false);
      // }

      if (isKeyMatch(key, keyMappings.Delete)) {
        e.preventDefault();
        setFocusedProductIndex(false);
        setIsProductSelectionActive(false);
      }

      if (isCategorySelectionActive) {
        if (isKeyMatch(key, keyMappings.ArrowRight)) {
          e.preventDefault();
          setFocusedProductIndex(false);

          if (i18n.language === "ar") {
            setHighlightedCategoryIndex((prev) => Math.max(prev - 1, -1));
          } else {
            setHighlightedCategoryIndex((prev) =>
              Math.min(prev + 1, categories.length),
            );
          }

          const carousel = carouselRef.current;
          const newHighlightedCategoryIndex =
            i18n.language === "ar"
              ? highlightedCategoryIndex - 1
              : highlightedCategoryIndex + 1;
          const selectedCategoryElement =
            carousel.children[newHighlightedCategoryIndex - 1];

          if (selectedCategoryElement) {
            const scrollPosition = carousel.scrollLeft;
            const categoryWidth = selectedCategoryElement.offsetWidth;

            if (i18n.language === "ar") {
              if (
                scrollPosition + carousel.offsetWidth <
                categoryWidth * newHighlightedCategoryIndex
              ) {
                carousel.scrollBy({
                  left: categoryWidth * 4,
                  behavior: "smooth",
                });
              }
            } else {
              if (
                scrollPosition + carousel.offsetWidth <
                categoryWidth * newHighlightedCategoryIndex
              ) {
                carousel.scrollBy({
                  left: categoryWidth * 4,
                  behavior: "smooth",
                });
              }
            }
          }
        }

        if (isKeyMatch(key, keyMappings.ArrowLeft)) {
          e.preventDefault();
          setFocusedProductIndex(false);

          if (i18n.language === "ar") {
            setHighlightedCategoryIndex((prev) =>
              Math.min(prev + 1, categories.length),
            );
          } else {
            setHighlightedCategoryIndex((prev) => Math.max(prev - 1, -1));
          }

          const carousel = carouselRef.current;
          const newHighlightedCategoryIndex =
            i18n.language === "ar"
              ? highlightedCategoryIndex + 1
              : highlightedCategoryIndex - 1;
          const selectedCategoryElement =
            carousel.children[newHighlightedCategoryIndex - 1];

          if (selectedCategoryElement) {
            const scrollPosition = carousel.scrollLeft;
            const categoryWidth = selectedCategoryElement.offsetWidth;

            if (i18n.language === "ar") {
              if (
                scrollPosition <
                categoryWidth * (newHighlightedCategoryIndex - 1)
              ) {
                carousel.scrollBy({
                  left: -categoryWidth * 1,
                  behavior: "smooth",
                });
              }
            } else {
              if (
                scrollPosition <
                categoryWidth * (newHighlightedCategoryIndex - 1)
              ) {
                carousel.scrollBy({
                  left: -categoryWidth * 2,
                  behavior: "smooth",
                });
              }
            }
          }
        }

        if (isKeyMatch(key, keyMappings.Enter)) {
          e.preventDefault();
          // const selectedCategory =
          //   highlightedCategoryIndex === 0
          //     ? { category_id: 0 }
          //     : categories[highlightedCategoryIndex - 1];

          if (highlightedCategoryIndex === -1) {
            // Call the function to handle the favorite category click
            handleFavoriteCategoryClick();
          } else {
            const selectedCategory =
              highlightedCategoryIndex === 0
                ? { category_id: 0 } // Assuming 0 is for the "All" category
                : categories[highlightedCategoryIndex - 1];

            handleCategoryClick(
              highlightedCategoryIndex,
              selectedCategory.category_id,
              true,
            );
            setIsCategorySelectionActive(highlightedCategoryIndex);
            setHighlightedCategoryIndex(highlightedCategoryIndex);
          }
        }
      }

      if (e.shiftKey && isKeyMatch(key, keyMappings.ArrowDown)) {
        e.preventDefault();
        setIsCategorySelectionActive(false);
        setIsProductSelectionActive(true);
        setFocusedProductIndex(0);
        searchInputRef.current.blur();
      }

      if (isProductSelectionActive) {
        if (isKeyMatch(key, keyMappings.ArrowRight)) {
          if (e.ctrlKey) return;
          e.preventDefault();
          if (i18n.language === "ar") {
            setFocusedProductIndex((prev) => Math.max(prev - 1, 0));
          } else {
            setFocusedProductIndex((prev) =>
              Math.min(prev + 1, products.length - 1),
            );
          }
        }

        if (isKeyMatch(key, keyMappings.ArrowLeft)) {
          if (e.ctrlKey) return;
          e.preventDefault();
          if (i18n.language === "ar") {
            setFocusedProductIndex((prev) =>
              Math.min(prev + 1, products.length - 1),
            );
          } else {
            setFocusedProductIndex((prev) => Math.max(prev - 1, 0));
          }
        }

        if (isKeyMatch(key, keyMappings[" "])) {
          e.preventDefault();
          if (focusedProductIndex !== null) {
            handleSelectProduct(products[focusedProductIndex]);
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    isCategorySelectionActive,
    highlightedCategoryIndex,
    categories,
    isProductSelectionActive,
    focusedProductIndex,
    products,
    isScannerActive,
    handleSelectProduct,
  ]);

  useEffect(() => {
    const keyMap = {
      S: ["S", "ٍ"],
    };

    const normalizeKey = (key) => {
      const normalizedKeys = {
        "ٍ": "S",
      };
      return normalizedKeys[key] || key;
    };

    const handleKeyDown = (e) => {
      const normalizedKey = normalizeKey(e.key);

      if (e.shiftKey && keyMap.S.includes(normalizedKey)) {
        e.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
        setIsProductSelectionActive(false);
        setIsCategorySelectionActive(false);
        setFocusedProductIndex(null);
        setHighlightedCategoryIndex(0);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const keyMap = {
      S: ["S", "ٍ"],
    };

    const normalizeKey = (key) => {
      const normalizedKeys = {
        "ٍ": "S",
      };
      return normalizedKeys[key] || key;
    };

    const handleKeyDown = (e) => {
      const normalizedKey = normalizeKey(e.key);

      if (e.shiftKey && keyMap.S.includes(normalizedKey)) {
        e.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
        setIsProductSelectionActive(false);
        setIsCategorySelectionActive(false);
        setFocusedProductIndex(null);
        setHighlightedCategoryIndex(0);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleRemoveProducts = async () => {
    try {
      setLoading(true);

      // console.log("handleRemoveProducts", selectedGroupProducts);

      const payload = {
        company_id: userData?.company_id,
        user_id: userData?.user_id,
        group_id: activeSubgroupId || activeGroupId,
        remove_product_ids: selectedGroupProducts,
      };

      // console.log("API Payload:", payload);

      const res = await axiosInstance.post(
        URLS.REMOVE_PRODUCTS_FROM_GROUP,
        payload,
      );
      const result = res?.data?.result?.[0];

      if (result?.status_code === 200) {
        toast.success(t("Products removed successfully"));

        const currentGroupId = activeSubgroupId || activeGroupId;

if (currentGroupId) {
  await getGroupProducts(currentGroupId);
}

        setIsSelectActive(false);
        setIsHampleButtom(false);
        setShowConfirmModal(false);
      } else {
        toast.error(result?.status || "Failed to remove products from group");
      }
    } catch (error) {
      console.error("Error removing products:", error);
      toast.error("حدث خطأ أثناء إزالة المنتجات من المجموعة");
    } finally {
      setLoading(false);
    }
  };

  const handleGroupSave = async (payload) => {
    try {
      setGroupLoading(true);

      // The modal now sends a fully-built payload:
      //   { user_id, company_id, name, name_ar,
      //     product_ids? | (is_create_sub_group, sub_groups_vals),
      //     parent_id?, remove_parent_id?, id? }
      // `id` is only present when editing an existing group.
      const { id, ...groupData } = payload;
      const isEditing = Boolean(id);

      // Swap `id` -> `group_id` to match what EditProductGroup expects.
      const finalPayload = isEditing ? { ...groupData, group_id: id } : groupData;
      const url = isEditing ? URLS.EDIT_PRODUCT_GROUP : URLS.CREATE_PRODUCT_GROUP;

      const res = await axiosInstance.post(url, finalPayload);
      // Create returns result as an array; Edit may return the object directly —
      // handle both shapes defensively.
      const result = res?.data?.result?.[0] ?? res?.data;

      if (result?.status === "with same name product group available.") {
        toast.error(t("Group name already exists. Please choose a different name."));
        return;
      }

      if (result?.status_code === 200) {
        toast.success(
          t(result?.status) ||
          (isEditing ? t("Group updated successfully") : t("Group created successfully"))
        );

        if (isEditing && !categorySelected) {
          await getGroupProducts(id);
          await getGroups();
        }
        getGroups();
        setSelectedGroupProducts(null);
        setIsSelectActive(false);
        setIsHampleButtom(false);
        setGroupModal(false);
        setOpenMoveProduct(false);
      } else {
        toast.error(result?.status || "Operation failed");
      }
    } catch (error) {
      console.error("Error saving group:", error);
      toast.error("Something went wrong while saving the group");
    } finally {
      setGroupLoading(false);
    }
  };

  const handleOpenModal = () => {
    setGroupModal(true); // Local state to open the modal
    dispatch(openGroupModal()); // Dispatch to set global state
  };

  const handleCloseModal = () => {
    setGroupModal(false); // Local state to close the modal
    dispatch(closeGroupModal()); // Dispatch to set global state
  };

  // console.log("selectedGroupProducts", selectedGroupProducts);

  const activeContextId = activeGroupId || activeSubgroupId; // whichever is set
  const hasFreeProduct = localProducts?.some(
    (product) => product?.isFreeProduct || product?.offer
  );

  return (
    <>
      {loading && <LoadingSpinner />}

      {OpenCashModal && openCashAllow && (
        <OpeningCash_Modal
          onClose={() => {
            dispatch(sessionstatesave(false));
          }}
        />
      )}
      {addProducModal && (
        <AddProductModal
          updateScreen={(id) => {
            setProductToAdd({});
            setAddProducModal(false);
            // handleCategoryClick(
            //   highlightedCategoryIndex,
            //   categories[highlightedCategoryIndex - 1]?.category_id,
            //   true
            // )
            // console.log("UAUUA",id);

            getProductsToAdd(id);
            // addRequestedProd()
          }}
          productToAdd={productToAdd}
          onCancel={() => {
            setProductToAdd({});
            setAddProducModal(false);
          }}
        />
      )}
      {requestProducModal && (
        <RequestProductModal
          isOpen={true}
          updateScreen={(id) => {
            setProductToRequest({});
            setRequestProducModal(false);

            getProductsToAdd(id);
          }}
          fetchedProduct={productToRequest}
          onCancel={() => {
            setProductToRequest({});
            setRequestProducModal(false);
          }}
        />
      )}

      {openPassword === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
        />
      )}
      {pendingFreeOffer && (
        <FreeOfferModal
          offers={pendingFreeOffer.eligibleOffers}
          quantity={pendingFreeOffer.parentProduct.quantity}
          selectedPromotionId={
            offerSelectionsRef.current[pendingFreeOffer.parentProduct.prod_id]?.selectedPromotionId
          }
          onSelect={handleSelectFreeOffer}
          onClose={handleCloseFreeOfferModal}
          isBillOffer={false}
        />
      )}

      <NewGroup_Modal
        open={groupModal}
        // onClose={() => setGroupModal(false)}
        onClose={handleCloseModal}
        onSave={handleGroupSave}
        // onOpen={() => dispatch(groupModalReducer(true))}
        groupLoading={groupLoading}
      />

      <AddGroupProduct_Modal
        open={addGroupProductModal}
        onClose={() => setAddGroupProductModal(false)}
        onSave={() => getGroupProducts(activeSubgroupId || activeGroupId)}
        groups={groups}
        activeGroupId={activeGroupId}
        activeSubgroupId={activeSubgroupId}
      // onSave={handleGroupSave}
      />

      <MoveProductsModal
        open={openMoveProduct}
        onClose={() => setOpenMoveProduct(false)}
        selectedProducts={selectedGroupProducts}
        groups={groups}
        onSave={handleGroupSave}
      />


      <div className="grid grid-cols-3 bg-[#EEEEEE] mt-2 gap-0 me-5">
        <ProductBox
          draftOrder={draftOrder}
          products={localProducts}
          userSelectedIndex={userSelectedIndex}
          setUserSelectedIndex={setUserSelectedIndex}
          // onRemoveProduct={handleRemoveProduct}
          onRemoveProduct={handleDeleteClick}
          onUpdateQuantity={handleUpdateQuantity}
          onUpdateDiscount={handleUpdateDiscount}
          isScannerActive={isScannerActive}
          returnProducts={returnProducts}
          groupModal={groupModal}
          addGroupProductModal={addGroupProductModal}
          isSelect={isSelect}
          onUpdateSP={onUpdateSP}
          onChooseOffer={handleReopenFreeOfferModal}
        // onClearCart={handleClearCart}
        />

        <div className="flex col-span-2 justify-start ps-4 relative">
          <div className="flex flex-col ps-6 w-full max-w-[100%]">
            <div className="flex flex-row justify-start gap-3 w-full">
              <div
                className="flex flex-row gap-3"
                style={{
                  width: isOrderButtonVisible ? "80%" : "100%",
                  ...(i18n.language === "ar"
                    ? { marginLeft: 10 }
                    : { marginRight: 10 }),
                }}
              >
                <div
                  className={` ${allowProductShortcut ? "w-10/12" : "w-full"}`}
                >
                  <ProductSearchBar
                    placeholder={t("Search product")}
                    // value={search}
                    ref={searchInputRef}
                    onSearch={(e) => {
                      const value = e.target.value;
                      // handleCategoryClick(0, 0)
                      setActiveGroupId(null);
                      setIsOfferButton(false)
                      setIsHampleButtom(false);
                      setsearch(value);
                      setIsProductSelectionActive(false);
                      setFocusedProductIndex(null);
                      debouncedGetProducts(value, "TEXT", categoryid);
                    }}
                    id="searchBar"
                    showBarcode={true}
                  />
                </div>

                {/* Short Code Search Bar  */}
                {allowProductShortcut && (
                  <div
                    className={`${deviceType == "tablet" ? "w-1/3" : "w-1/4"}`}
                  >
                    <ShortCodeSearchBar
                      placeholder={t("Search Short Code")}
                      value={shortCutSearchValue}
                      ref={shortCodeInputRef}
                      onSearch={(value) => {
                        setShortcutSearchValue(value);
                        setActiveGroupId(null);
                        setIsHampleButtom(false);
                        setsearch("");
                        setIsProductSelectionActive(false);
                        setFocusedProductIndex(null);
                        debouncedGetShortCutProducts(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (shortcutProducts?.length > 0) {
                            const product = shortcutProducts[0];
                            handleSelectProduct(product, shortCutSearchValue);

                            setShortcutSearchValue("");
                            setShortCutProducts([]);
                            e.preventDefault();
                          } else {
                            toast.error(
                              t("No product found with this short code"),
                            );
                          }
                        }
                      }}
                      onClear={() => {
                        setShortcutSearchValue("");
                        setShortCutProducts([]); // Clear results also
                      }}
                    />
                  </div>
                )}
              </div>
              { allowCreateOrEditGroups && (
                <NewGroupButton
                  // onClick={() => setGroupModal(true) }
                  onClick={handleOpenModal}
                />
              )}
              {Object.keys(localProducts).length > 0 && (
                <NewOrderButton onClick={handleNewOrderClick} />
              )}
            </div>
           
              <div className="flex flex-row items-center ">
                {!isScrollAtStart && (
                  <button
                    className={`mt-2 ${i18n.language === "ar"
                      ? "bg-gradient-to-r from-[#EEEEEE] to-[#7EC242]"
                      : "bg-gradient-to-l from-[#EEEEEE] to-[#7EC242]"
                      } font-bold focus:outline-none hover:${i18n.language === "ar"
                        ? "bg-gradient-to-r"
                        : "bg-gradient-to-l"
                      } rounded-lg p-2`}
                    onClick={() =>
                      i18n.language === "ar"
                        ? scrollToNextItem()
                        : scrollToPrevItem()
                    }
                  >
                    <img
                      src={i18n.language === "ar" ? right_scroll : left_scroll}
                      className="h-6 w-12"
                      alt="Scroll Icon"
                    />
                  </button>
                )}

                <div
                  className="flex overflow-x-auto scrollbar-hidden"
                  ref={carouselRef}
                  onScroll={handleScroll}
                >
                  {categoriesLoading ? (
                    <CategorySkeleton />
                  ) : (
                    <>
                      {showFav === true && (
                        <CategoryButton
                          active={categoryid === "fav"}
                          highlighted={highlightedCategoryIndex === -1}
                          // onClick={handleFavoriteCategoryClick}
                          onClick={() => {
                            handleFavoriteCategoryClick();
                            setCategorySelected(true);
                            setIsOfferButton(false)
                            setOfferSelected("buy_x_get_y")

                          }}
                        >
                          <img
                            className="h-5 mb-0.5 w-auto justify-center items-center"
                            src={star_icon}
                            alt="Favourite"
                          />
                        </CategoryButton>
                      )}

                      {/* Default “All” */}
                      <CategoryButton
                        active={categoryid === 0}
                        highlighted={highlightedCategoryIndex === 0}
                        // onClick={() => handleCategoryClick(0, 0, true)}
                        onClick={() => {
                          handleCategoryClick(0, 0, true);
                          setIsOfferButton(false)

                          setCategorySelected(true);
                          setIsSelectActive(false);
                          setIsHampleButtom(false);
                          setOfferSelected("buy_x_get_y")

                        }}
                      >
                        {t("All")}
                      </CategoryButton>

                      <CategoryButton
                        type="offer"
                        active={isOfferButton}
                        offerTab
                        onClick={() => {
                          handleSelectOffers();
                          setIsSelectActive(false);
                          setActiveGroupId(null);
                          setActiveIndex(null);
                          setIsOfferButton(true);
                          setIsHampleButtom(false);
                        }}
                      >
                        <GiftOutlined style={{ marginRight: 4 }} />
                        {t("Offers")}
                      </CategoryButton>


                      {/* Hamper  */}
                      <CategoryButton
                        // key={`grp-${gIndex}`}
                        type="hamper"
                        active={isHamperButton}
                        onClick={() => {
                          handleSelectHamper();
                          setIsSelectActive(false);
                          setIsOfferButton(false)
                          setActiveGroupId(null)
                          setIsHampleButtom(true);
                          setActiveIndex(null);
                          setOfferSelected("buy_x_get_y")

                        }}
                      >
                        {t("Hampers")}
                      </CategoryButton>

                      {/* Groups (purple) */}
                      {groups?.map((group, gIndex) => (
                        <CategoryButton
                          key={`grp-${gIndex}`}
                          type="group"
                          active={activeGroupId === group.id}
                          onClick={() => {
                            handleGroupClick(group.id);
                            setIsSelectActive(false);
                            setIsHampleButtom(false);
                            setIsOfferButton(false)
                            setOfferSelected("buy_x_get_y")

                          }}
                        >
                          {group.name}
                        </CategoryButton>
                      ))}

                      {/* Categories (blue) */}
                      {showcategory && showCategoriesBasedOnContract && categories?.map((category, index) => (
                        <CategoryButton
                          key={`cat-${index}`}
                          type="category"
                          active={categoryid === category?.category_id}
                          highlighted={highlightedCategoryIndex === index + 1}
                          // onClick={() =>
                          //   handleCategoryClick(
                          //     index + 1,
                          //     category?.category_id,
                          //     true
                          //   )
                          // }
                          onClick={() => {
                            handleCategoryClick(
                              index + 1,
                              category?.category_id,
                              true,
                            );
                            setCategorySelected(true);
                            setIsSelectActive(false);
                            setIsHampleButtom(false);
                            setIsOfferButton(false)
                            setOfferSelected("buy_x_get_y")


                          }}
                        >
                          {i18n.language === "ar"
                            ? category.name_ar
                            : category.name}
                        </CategoryButton>
                      ))}
                    </>
                  )}
                </div>

                {!isScrollAtEnd && (
                  <button
                    className={`mt-2 ${i18n.language === "ar"
                      ? "bg-gradient-to-l"
                      : "bg-gradient-to-r"
                      } from-[#EEEEEE] to-[#7EC242] rounded-lg p-2`}
                    onClick={() =>
                      i18n.language === "ar"
                        ? scrollToPrevItem()
                        : scrollToNextItem()
                    }
                  >
                    <img
                      src={i18n.language === "ar" ? left_scroll : right_scroll}
                      className="h-6 w-12"
                      alt="Scroll Icon"
                    />
                  </button>
                )}
              </div>
                 <>
                <div className="justify-items-end mt-2 gap-2 flex flex-row justify-between">
                  <div
                    className="flex mx-2"
                    style={{ width: 500 }}
                  >
                    {isOfferButton ? (
                      offerTypes.map((offerType) => {
                        const billAmountoffer = offerType?.key === "bill_amount_off"

                        if(hasFreeProduct && billAmountoffer){
                          return (
                            <>
                            </>
                          )
                        }
                        else{
                        return (
                        <CategoryButton
                          key={offerType.key}
                          active={offerSelected === offerType.key}
                          onClick={() => {
                            console.log("Clicked offer type:", offerType.key);
                            setOfferSelected(offerType.key);
                          }}
                        >
                          {t(offerType.value)}
                        </CategoryButton>
                        
                      )
                      }
                      }))
                    : (
                      <>
                        {activeSubgroups.length > 0 && (
                          <CategoryButton
                            key="all"
                            type="group"
                            active={activeSubgroupId === "all"}
                            onClick={() => handleSubgroupClick("all")}
                          >
                            {t("All")}
                          </CategoryButton>
                        )}

                        {activeSubgroups.map((sub) => (
                          <CategoryButton
                            key={sub.id}
                            type="group"
                            active={activeSubgroupId === sub.id}
                            onClick={() => handleSubgroupClick(sub.id)}
                          >
                            {sub.name}
                          </CategoryButton>
                        ))}
                      </>
                    )}
                  </div>

                  {!productsLoading && (
                    <div className="flex flex-row gap-4">
                      {isSelectActive &&
                        selectedGroupProducts?.length > 0 &&
                        !activeGroupId && (
                          <button
                            className={`flex justify-center items-center w-[20vh] py-2 font-normal border text-black whitespace-nowrap rounded-lg cursor-pointer transition-all duration-200 ${isSelectActive
                              ? "bg-[#FFE99E] border-[#FFE99E] text-black hover:bg-[#FFE99E]"
                              : "bg-white border-gray-400 hover:bg-gray-100"
                              }`}
                            onClick={() => setOpenMoveProduct(true)}
                          >
                            <span className="flex flex-row items-center ms-1 font-semibold">
                              {t("Move")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="ms-2"
                              >
                                <path d="M3 12h18M12 3l10 9-10 9" />
                              </svg>
                            </span>
                          </button>
                        )}

                      {selectedGroupProducts?.length > 0 &&
                        products?.length > 0 &&
                        activeGroupId && !isAllSubgroupSelected && (
                          <button
                            className={`flex justify-center items-center w-[16vh] py-2 font-normal border text-[#FF1616] whitespace-nowrap rounded-lg cursor-pointer transition-all duration-200 ${isSelectActive
                              ? "bg-[#FFD5D5] border-[#FF1616] text-black hover:bg-[#FFD5D5]"
                              : "bg-white border-gray-400 hover:bg-gray-100"
                              }`}
                            onClick={() => setShowConfirmModal(true)}
                          >
                            <span className="flex flex-row items-center font-semibold">
                              {/* 🗑 Trash Icon */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="red"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="me-2"
                              >
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6l-1 14H6L5 6" />
                                <path d="M10 11v6M14 11v6" />
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                              </svg>

                              {t("Remove")}
                            </span>
                          </button>
                        )}

                      {activeGroupId && allowCreateOrEditGroups && !isAllSubgroupSelected && (
                        <button
                          className={`flex justify-center items-center w-[15vh] py-2 font-normal border text-purple-800 whitespace-nowrap rounded-lg cursor-pointer transition-all duration-200 ${isSelectActive
                            ? "bg-[#DFDFFF] border-[#A191FF] text-black hover:bg-[##DFDFFF]"
                            : "bg-white border-gray-400 hover:bg-gray-100"
                            }`}
                          onClick={() => setAddGroupProductModal(true)}
                        >
                          <span className="flex flex-row items-center font-semibold">
                            {/* ➕ Plus Icon */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="purple"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="me-2"
                            >
                              <line x1="12" y1="5" x2="12" y2="19" />
                              <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>

                            {t("Add")}
                          </span>
                        </button>
                      )}

                      {/* Select/Unselect Button */}
                      {products?.length > 0 && allowCreateOrEditGroups && !isOfferButton && !isAllSubgroupSelected && (
                        <button
                          onClick={() => setIsSelectActive((prev) => !prev)}
                          className={`flex justify-center w-[20vh] py-2 font-normal border text-black whitespace-nowrap rounded-lg cursor-pointer transition-all duration-200 ${isSelectActive
                            ? "bg-green-500 border-green-500 text-white hover:bg-green-600"
                            : "bg-white border-gray-400 hover:bg-gray-100"
                            }`}
                        >
                          <span className="mt-0.5 ms-1 font-semibold">
                            {isSelectActive ? t("Unselect") : t("Select")}
                          </span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
                {productsLoading ? (
                  <>
                    {/* <div
                     className=" mx-3 mt-2"
                style={{
                  width:  500,
                }}
              >
                <ProductSearchBar
                  value={shortCutSearchValue} 
                  placeholder={t("Search Shortcut")}
                  ref={searchInputRef}
                  onSearch={(e) => {
                    const value = e.target.value;
                    // if(value?.length == 1){
                    //   setProducts([])
                    // }
                    // handleCategoryClick(0, 0)
                    setShortcutSearchValue(value)
                    setActiveGroupId(null);
                    setsearch('');
                    setIsProductSelectionActive(false);
                    setFocusedProductIndex(null);
                    debouncedGetShortCutProducts(value);
                  }}
                  id="searchBar"
                />
              </div> */}
                    <ProductGridSkeleton />
                  </>
                ) : (
                  <>
                    {/* Confirmation Modal */}
                    <Modal
                      open={showConfirmModal}
                      onCancel={() => setShowConfirmModal(false)}
                      footer={null}
                      centered
                      closable={false}
                    >
                      <div className="text-center p-6">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800">
                          {t(
                            "Are you sure you want to remove the products from this group?",
                          )}
                        </h3>
                        <div className="flex justify-center gap-4 mt-6">
                          <button
                            onClick={() => setShowConfirmModal(false)}
                            className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                          >
                            {t("No")}
                          </button>
                          <button
                            onClick={handleRemoveProducts}
                            disabled={loading}
                            className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                          >
                            {loading ? t("Removing...") : t("Yes")}
                          </button>
                        </div>
                      </div>
                    </Modal>

                    {offerSelected === "bill_free_item" && (
                      <div
                        className="flex items-center gap-2 m-2 px-3 py-2 rounded-md text-sm font-medium"
                        style={{
                          background: "#fff7e6",
                          border: "1px solid #ffd591",
                          color: "#874d00",
                        }}
                      >
                        <img src={info_icon} alt="info" className="w-5 h-5 object-contain" />
                        <span >{t("Add eligible products to your cart to meet the required bill amount. Once eligible, this free item will be applied automatically.")}</span>
                        {/* e.g. "Free item products cannot be selected individually" */}
                      </div>
                    )}
                    {offerSelected === "bill_amount_off" && (
                      <div
                        className="flex items-center gap-2 m-2 px-3 py-2 rounded-md text-sm font-medium"
                        style={{
                          background: "#fff7e6",
                          border: "1px solid #ffd591",
                          color: "#874d00",
                        }}
                      >
                        <img src={info_icon} alt="info" className="w-5 h-5 object-contain" />
                        <span >{t("Add eligible products to your cart to meet the required bill amount. Once eligible, this offer will be applied automatically.")}</span>
                        {/* e.g. "Free item products cannot be selected individually" */}
                      </div>
                    )

                    }

                    <ProductGrid
                      searchValue={search}
                      onSelectProduct={handleSelectProduct}
                      products={
                        shortcutProducts.length > 0
                          ? shortcutProducts
                          : products
                      }
                      selectedOfferType={offerSelected}
                      isOfferButton={isOfferButton}
                      offerTypes={offerTypes}
                      categoryButton={CategoryButton}
                      focusedProductIndex={focusedProductIndex}
                      productsLoading={productsLoading}
                      isSelectActive={isSelectActive}
                      setSelectedGroupProducts={setSelectedGroupProducts}
                      selectedGroupProducts={selectedGroupProducts}
                      activeGroupId={activeGroupId}
                      onLoadMore={handleLoadMore}
                      hasMore={hasMore}
                      isLoadingMore={isLoadingMore}
                      isFavouriteProd={categoryid === "fav"}
                    />
                  </>
                )}
              </>
            {/* {!showcategory && search === "" ? (
              <>
                <div className="flex flex-col items-center mt-28 h-full py-10 text-center">
                  <img
                    src={search_image}
                    alt="Search products"
                    className="w-80 h-80 object-contain opacity-100"
                  />
                  <h2 className="text-xl font-semibold text-gray-700 mb-2">
                    {t("Search for Products")}
                  </h2>
                  <p className="text-gray-500 max-w-md">
                    {t(
                      "Use the searchbar above to find items quickly and add them to your cart.",
                    )}
                  </p>
                </div>
              </>
            ) : (
              null
            )} */}
          </div>

        </div>
        <BarcodeReader
          onScan={(data) => {
            // setIsScannerActive(true);
            // setFocusedProductIndex(null);
            // handleCategoryClick(0, 0, true);
            // handleCategoryClick(0, 0, true, true);
            if (categoryid != "fav" && showFav === true) {
              handleFavoriteCategoryClick();
            }
            setsearch("");
            // console.log("barcode called===>", data)
            getProductsSearch(data, "BARCODE");
          }}
          preventDefault={true}
          stopPropagation={false}
          onError={(err) => {
            console.error(err);
          }}
          facingMode="environment"
        // className="absolute inset-y-0 right-0 mt-2 mr-4 pointer-events-none cursor-pointer z-10"
        />
      </div>
    </>
  );
};

export default ProductCo;
